import * as appSelector from './app.selectors';
import * as routerSelector from './router.selectors';
import * as checkoutSelector from './checkout.selectors';
import * as supportSelector from './support.selectors';
import * as followupSelector from './followup.selectors';

const fromSelectors = {
  ...appSelector,
  ...routerSelector,
  ...checkoutSelector,
  ...supportSelector,
  ...followupSelector,
};

export { fromSelectors };
